'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/rydges/node_modules/axios/lib/platform/index.js
// module id = 16
// module chunks = 0